import { useState, useEffect } from 'react';
import ApiClient from "../../methods/api/apiClient";
import Layout from "../../components/global/layout";
import { Disclosure } from '@headlessui/react';
import { IoMdAdd, IoMdRemove } from 'react-icons/io';
import Pagination from 'react-js-pagination';
import loader from '../../methods/loader';


const Faqs = () => {
  const [faqs, setFaqs] = useState([]);
  const [filters, setFilters] = useState({ page: 1, count: 10, status: "active" });
  const [total, setTotal] = useState(0)

  useEffect(() => {
    getFaqs();
  }, []);

  const getFaqs = (f = {}) => {
    const payload = { ...filters, ...f }
    loader(true)
    ApiClient.get(`faq/listing`, payload).then(res => {
      if (res.success) {
        setFaqs(res.data)
        setTotal(res?.total)
      }
      loader(false)
    })
  }

  const handlePagination = (e) => {
    setFilters({ ...filters, page: e });
    getFaqs({ page: e });
  };

  return (
    <Layout>
      <div className="bg-white py-10 lg:py-20">
        <div className="max-w-2xl mx-auto p-6 bg-white">
          <h1 className="text-3xl font-bold mb-6 text-center">Frequently Asked Questions</h1>
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <Disclosure key={index}>
                {({ open }) => (
                  <div className="border border-gray-300 rounded-lg shadow-md">
                    <Disclosure.Button className="w-full bg-gray-100 p-4 text-left font-semibold text-lg flex justify-between items-center rounded-lg hover:bg-gray-200 transition duration-200">
                      <h3>{faq.question}</h3>
                      {open ? (
                        <IoMdRemove className="text-2xl shrink-0" />
                      ) : (
                        <IoMdAdd className="text-2xl shrink-0" />
                      )}
                    </Disclosure.Button>
                    <Disclosure.Panel className="bg-white p-4 rounded-b-lg">
                      <p className="text-gray-700">{faq.answer}</p>
                    </Disclosure.Panel>
                  </div>
                )}
              </Disclosure>
            ))}
          </div>
          {total > filters?.count ?
            <div className="mt-10 flex items-center justify-end">
              <Pagination
                activePage={filters?.page}
                itemsCountPerPage={filters?.count}
                totalItemsCount={total}
                pageRangeDisplayed={3}
                onChange={handlePagination}
                hideFirstLastPages={true}
              />
            </div>
            : null}
        </div>
      </div>
    </Layout>
  );
};

export default Faqs;
